import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCategoriaPersonal = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'categoria_personal',
        name: 'Categoria Personal',
        component: ViewCategoriaPersonal,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
